
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import ClubForm from "./ClubForm";
import { Club as ClubType } from "@/types/database-extensions";

// Using the shared Club type from database-extensions
interface ClubDialogProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
  currentClub: Partial<ClubType>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
  isSubmitting: boolean;
  handleImageChange?: (url: string) => void;
}

const ClubDialog = ({
  isDialogOpen,
  setIsDialogOpen,
  currentClub,
  handleInputChange,
  handleSubmit,
  isSubmitting,
  handleImageChange,
}: ClubDialogProps) => {
  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>
            {currentClub.id ? "Edit Club" : "Create Club"}
          </DialogTitle>
        </DialogHeader>
        <ClubForm
          currentClub={currentClub}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          setIsDialogOpen={setIsDialogOpen}
          handleImageChange={handleImageChange}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ClubDialog;
